(function(){
  var header=document.querySelector('header');
  var burger=document.querySelector('.burger');
  if(burger&&header){burger.addEventListener('click',function(){header.classList.toggle('nav-open');});}
  if(header){window.addEventListener('scroll',function(){header.style.boxShadow=window.scrollY>12?'0 10px 30px rgba(0,0,0,.45)':'none';},{passive:true});}

  var prefersReduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=document.querySelectorAll('.reveal');
  if(prefersReduced||!('IntersectionObserver' in window)){
    els.forEach(function(el){el.classList.add('in');});
  }else{
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
    },{threshold:.15,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el);});
  }

  /* hero parallax */
  (function(){
    var hero=document.querySelector('.hero-banner');
    if(!hero||prefersReduced)return;
    var img=hero.querySelector('.hero-bgimg');
    if(!img)return;
    var ticking=false,factor=0.08;
    function update(){
      ticking=false;
      if(window.innerWidth<=820){img.style.transform='';return;}
      var top=hero.getBoundingClientRect().top;
      if(top>window.innerHeight||top<-hero.offsetHeight)return;
      var y=(-top)*factor;
      img.style.transform='translate3d(0,'+y.toFixed(1)+'px,0) scale(1.18)';
    }
    function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
  })();

  /* infinite carousel */
  (function(){
    var track=document.getElementById('carTrack');
    if(!track||track.children.length===0)return;
    var reduced=prefersReduced;
    var count=track.children.length;
    track.innerHTML=track.innerHTML+track.innerHTML;
    var offset=0,setWidth=0,paused=false,animating=false;
    function gap(){var s=getComputedStyle(track);return parseFloat(s.columnGap||s.gap)||26;}
    function measure(){var g=gap(),w=0,kids=track.children;for(var i=0;i<count;i++){w+=kids[i].getBoundingClientRect().width+g;}setWidth=w;}
    function render(){var m=offset;if(setWidth>0){m=offset%setWidth;if(m>0)m-=setWidth;}track.style.transform='translateX('+m+'px)';}
    measure();render();
    window.addEventListener('resize',function(){measure();render();},{passive:true});
    var SPEED=0.35;
    function tick(){if(!reduced&&!paused&&!animating){offset-=SPEED;render();}requestAnimationFrame(tick);}
    requestAnimationFrame(tick);
    var car=track.closest('.carousel');
    ['mouseenter','focusin'].forEach(function(e){car.addEventListener(e,function(){paused=true;});});
    ['mouseleave','focusout'].forEach(function(e){car.addEventListener(e,function(){paused=false;});});
    function step(dir){
      if(animating)return;
      var stepW=track.children[0].getBoundingClientRect().width+gap();
      var start=offset,target=offset+dir*stepW;
      if(reduced){offset=target;render();return;}
      animating=true;var t0=null,dur=420;
      function ease(t){return 1-Math.pow(1-t,3);}
      function anim(ts){if(t0===null)t0=ts;var p=Math.min(1,(ts-t0)/dur);offset=start+(target-start)*ease(p);render();if(p<1)requestAnimationFrame(anim);else animating=false;}
      requestAnimationFrame(anim);
    }
    var nx=car.querySelector('.car-next'),pv=car.querySelector('.car-prev');
    if(nx)nx.addEventListener('click',function(){step(-1);});
    if(pv)pv.addEventListener('click',function(){step(1);});
    var viewport=car.querySelector('.car-viewport');
    var dragging=false,startX=0,startOff=0,moved=0;
    viewport.addEventListener('pointerdown',function(e){
      dragging=true;startX=e.clientX;startOff=offset;moved=0;paused=true;animating=false;
      viewport.classList.add('dragging');
      try{viewport.setPointerCapture(e.pointerId);}catch(_){}
    });
    viewport.addEventListener('pointermove',function(e){
      if(!dragging)return;moved=Math.abs(e.clientX-startX);offset=startOff+(e.clientX-startX);render();
    });
    function endDrag(e){
      if(!dragging)return;dragging=false;paused=false;
      viewport.classList.remove('dragging');
      try{viewport.releasePointerCapture(e.pointerId);}catch(_){}
      if(e.type==='pointerup'&&moved<=6){
        var el=document.elementFromPoint(e.clientX,e.clientY);
        var card=el&&el.closest?el.closest('a.card[href]'):null;
        if(card)window.location.href=card.getAttribute('href');
      }
    }
    viewport.addEventListener('pointerup',endDrag);
    viewport.addEventListener('pointercancel',endDrag);
    viewport.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();},true);
  })();
})();
